import { render, staticRenderFns } from "./Cnae.vue?vue&type=template&id=4cc1cfb6"
import script from "./Cnae.vue?vue&type=script&lang=js"
export * from "./Cnae.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports